import React, { useEffect } from "react";
import { usePreventPageLeaveStore } from "./store/usePreventPageLeaveStore";

const PreventPageLeave = ({ children }: React.PropsWithChildren) => {
  const { isPreventing } = usePreventPageLeaveStore();

  useEffect(() => {
    if (!isPreventing || typeof window === "undefined") {
      return;
    }

    function beforeUnload(event: BeforeUnloadEvent) {
      event.preventDefault();

      // Included for legacy support, e.g. Chrome/Edge < 119
      event.returnValue = true;
    }

    window.addEventListener("beforeunload", beforeUnload);
    return () => {
      window.removeEventListener("beforeunload", beforeUnload);
    };
  }, [isPreventing]);

  return children;
};

export default PreventPageLeave;
